/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AttestationChallengeResponse } from '../models/AttestationChallengeResponse';
import type { AttestationVerifyRequest } from '../models/AttestationVerifyRequest';
import type { AttestationVerifyResponse } from '../models/AttestationVerifyResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileAttestationService {
    /**
     * Issue a device-attestation challenge
     * Mint a single-use nonce the client binds its attestation token to. Requires an authenticated mobile session.
     * @param xMobileAuth
     * @returns AttestationChallengeResponse Successful Response
     * @throws ApiError
     */
    public static issueAttestationChallenge(
        xMobileAuth?: (string | null),
    ): CancelablePromise<AttestationChallengeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v2/auth/attestation/challenge',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify a device attestation
     * Verify the attestation token against the server-issued challenge. Rejected unless a challenge was issued for this device.
     * @param requestBody
     * @param xMobileAuth
     * @returns AttestationVerifyResponse Successful Response
     * @throws ApiError
     */
    public static verifyAttestation(
        requestBody: AttestationVerifyRequest,
        xMobileAuth?: (string | null),
    ): CancelablePromise<AttestationVerifyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v2/auth/attestation/verify',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
